// extracted by mini-css-extract-plugin
export default {"volume":"Volume_volume__Prz+O","input":"Volume_input__A1Clc","volumeBar":"Volume_volumeBar__aUK2p"};